import type { IUsageFeeTier, IUsageFeeTierKey } from '../types';

export const getUsageFeeDataByTierKey = (
  usageFeeTiers?: IUsageFeeTier[],
  tierKey?: IUsageFeeTierKey,
): IUsageFeeTier | undefined => {
  return usageFeeTiers?.find((item) => item.tierKey === tierKey);
};
